module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/diners-club-payment-card-853c40262b8eac67b1b7fe0b0636cd64.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/diners-club-payment-card.svg
// module id = rbBd
// module chunks = 24